import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'antd';
import { link, border } from '../../configs/designTokens';
import {
  CheckCircleOutlined,
  TeamOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import '../../styles/index.scss';

const TeamDetailsStats = ({ team, tasks }) => {
  const stats = useMemo(() => {
    const totalTasks = (tasks || []).length;
    const completedTasks = (tasks || []).filter(
      (task) => task.status === 'COMPLETED' || task.status === 'DONE'
    ).length;
    const completionPercentage = totalTasks > 0
      ? Math.round((completedTasks / totalTasks) * 100)
      : 0;
    const membersCount = team?.members?.length || 0;

    return {
      totalTasks,
      completedTasks,
      completionPercentage,
      membersCount,
    };
  }, [team, tasks]);

  return (
    <div className="project-stats project-stats--desktop">
      <div className="project-stats__grid">
        {/* Members */}
        <div className="project-stats__card">
          <div className="project-stats__card-header">
            <TeamOutlined className="project-stats__card-icon project-stats__card-icon--primary" />
            <span className="project-stats__card-label">Members</span>
          </div>
          <div className="project-stats__card-value">{stats.membersCount}</div>
          <div className="project-stats__card-sublabel">team members</div>
        </div>

        {/* Completion */}
        <div className="project-stats__card">
          <div className="project-stats__card-header">
            <CheckCircleOutlined className="project-stats__card-icon project-stats__card-icon--success" />
            <span className="project-stats__card-label">Completion</span>
          </div>
          <div className="project-stats__card-value">{stats.completionPercentage}%</div>
          <Progress
            percent={stats.completionPercentage}
            showInfo={false}
            strokeColor={link.blue}
            trailColor={border.slate}
            className="project-stats__card-progress"
          />
        </div>

        {/* Total Tasks */}
        <div className="project-stats__card">
          <div className="project-stats__card-header">
            <UnorderedListOutlined className="project-stats__card-icon project-stats__card-icon--warning" />
            <span className="project-stats__card-label">Tasks</span>
          </div>
          <div className="project-stats__card-value">{stats.completedTasks}</div>
          <div className="project-stats__card-sublabel">of {stats.totalTasks} total tasks</div>
        </div>
      </div>
    </div>
  );
};

TeamDetailsStats.propTypes = {
  team: PropTypes.object,
  tasks: PropTypes.array,
};

TeamDetailsStats.defaultProps = {
  team: null,
  tasks: [],
};

export default TeamDetailsStats;
